import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { notArrayOrEmpty } from 'src/misc/Misc';
import useAsyncProcesses from 'src/hooks/useAsyncProcesses';
import { getServicesPropQuery } from 'src/api/teacket';

const DashboardFiltersUsers = ({ serviceIdList }) => {
  const { executeAsyncProcess } = useAsyncProcesses();
  const [roleList, setRoleList] = useState(null);

  useEffect(() => {
    console.log('serviceIdList:', serviceIdList);
    if (true === notArrayOrEmpty(serviceIdList)) {
      setRoleList(null);
      return;
    }
    loadRoleList();
  }, [serviceIdList]);

  const loadRoleList = () => {
    console.log('loadRoleList()');
    executeAsyncProcess(async () => {
      try {
        const result = await getServicesPropQuery(serviceIdList, ['roleList'], ['role']);

        setRoleList(result?.map((x) => x.role));
      } catch (error) {
        console.log(error);
      }
    });
  };

  return <>{roleList?.join(', ')}</>;
};

DashboardFiltersUsers.propTypes = {
  serviceIdList: PropTypes.array,
};

export default DashboardFiltersUsers;
